import { ReactElement } from "react";

interface Props {
    texto: string;
    icon?: ReactElement<any, any>;
    isSelected?: boolean;
    onClick?: () => void;
}

export function MenuItem({ texto, icon, onClick, isSelected }: Props) {

    return (
        <div
            onClick={onClick}
            className={`flex gap-x-2 cursor-pointer hover:bg-gray-200 mx-3 rounded px-2 py-1 ${isSelected ? "bg-gray-200" : ""}`}>
            {icon}
            <p className="font-semibold text-lg">{texto}</p>
        </div>
    );
}